import { Routes } from '@angular/router';
import {HomeComponent} from './modules/home/home.component';
import {AppGuard} from './tinea-components/okta/auth/guards/app-guard';
import {OktaCallbackComponent} from '@okta/okta-angular';
import { ErrorComponent } from './shared/components/error/error.component';
import {
  LoggedInCallBackComponent
} from './tinea-components/okta/components/logged-in-call-back/logged-in-call-back.component';
import {
  OktaCustomCallBackComponent
} from './tinea-components/okta/components/okta-custom-call-back/okta-custom-call-back.component';
import {RoutingService} from './services';
import {RouteId} from './enums/env/routes-id-enum';
import {AdministrationGuard} from './modules/administration/guards/administration-guard';
import {pendingExportRequestChangesGuard} from './shared/gards/pending-changes.guard';
import {DafGuard} from './modules/processing-request-management/guards/daf-guard';
import {ReportingGuard} from './modules/reporting/guards/reporting-guard';

export const routes: Routes = [
  { path: 'implicit/callback', component: OktaCallbackComponent },
  { path: 'logged-in-callback', component: LoggedInCallBackComponent },
  { path: 'implicit/custom-callback', component: OktaCustomCallBackComponent },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AppGuard],
    pathMatch: 'full'
  },
  {
    path: RoutingService.getPathRoute(RouteId.ADMINISTRATION),
    canActivate: [AppGuard, AdministrationGuard],
    loadChildren: () =>
      import('./modules/administration/administration.module').then(m => m.AdministrationModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.EXPORT_TEMPLATE),
    canActivate: [AppGuard, ReportingGuard],
    loadChildren: () =>
      import('./modules/export-template/export-template.module').then(m => m.ExportTemplateModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.EXPORT_REQUEST),
    canActivate: [AppGuard, ReportingGuard],
    loadChildren: () =>
      import('./modules/export-request/export-request.module').then(m => m.ExportRequestModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.EXPORT_CREATION),
    canActivate: [AppGuard, ReportingGuard],
    canDeactivate: [pendingExportRequestChangesGuard],
    loadChildren: () =>
      import('./modules/export-creation/export-creation.module').then(m => m.ExportCreationModule)
  },
  {
    path: RoutingService.getPathRoute(RouteId.PROCESSING_REQUEST_MANAGEMENT),
    canActivate: [AppGuard, DafGuard],
    loadChildren: () =>
      import('./modules/processing-request-management/processing-request-management.module').then(m => m.ProcessingRequestManagementModule)
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [AppGuard],
    pathMatch: 'full'
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];
